import { render, staticRenderFns } from "./StandaloneReports.vue?vue&type=template&id=31920c86&"
import script from "./StandaloneReports.vue?vue&type=script&lang=js&"
export * from "./StandaloneReports.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StandaloneReports.vue"
export default component.exports